<template>
  <div class="reset-password">
    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step color="primary darken-4" :complete="e1 > 1" step="1">Account</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step color="primary darken-4" :complete="e1 > 2" step="2">Verify</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step color="primary darken-4" step="3">Reset Password</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-form ref="form1" class="mt-2" v-model="valid1" lazy-validation>
                  <v-text-field
                    v-model="storeUsername"
                    :rules="requiredFieldRules"
                    label="Username"
                    color="primary darken-4"
                    :class="{ 'mb-3': !valid1 }"
                    validate-on-blur
                    outlined
                    :readonly="isAuthenticated"
                  ></v-text-field>
                </v-form>

                <v-btn
                  outlined
                  class="text-capitalize primary--text text--darken-4"
                  @click="sendResetCode()"
                >Send Code</v-btn>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-form ref="form2" class="mt-2" v-model="valid2" lazy-validation>
                  <v-text-field
                    v-model="verificationCode"
                    :rules="requiredFieldRules"
                    label="Verification Code"
                    color="primary darken-4"
                    :class="{ 'mb-3': !valid2 }"
                    validate-on-blur
                    outlined
                  ></v-text-field>
                </v-form>

                <v-btn
                  outlined
                  class="text-capitalize primary--text text--darken-4"
                  @click="verifyResetCode()"
                >Verify</v-btn>

                <v-btn
                  text
                  depressed
                  class="text-capitalize primary--text text--darken-4"
                  @click="sendResetCode2()"
                >Resend</v-btn>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-form ref="form3" class="mt-2" v-model="valid3" lazy-validation>
                  <v-text-field
                    type="password"
                    v-model="newPassword"
                    :rules="newPasswordRules"
                    label="New password"
                    color="primary darken-4"
                    :class="{ 'mb-3': !valid3 }"
                    validate-on-blur
                    outlined
                  ></v-text-field>

                  <v-text-field
                    type="password"
                    v-model="confirmPassword"
                    :rules="confirmPasswordRules"
                    label="Confirm new password"
                    color="primary darken-4"
                    :class="{ 'mb-3': !valid3 }"
                    validate-on-blur
                    outlined
                  ></v-text-field>
                </v-form>

                <v-btn small color="primary darken-4" @click="resetPassword()">Reset Password</v-btn>

                <v-btn text depressed class="text-capitalize primary--text text--darken-4">Cancel</v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ResetPassword",
  data() {
    return {
      e1: 1,
      valid1: true,
      valid2: true,
      valid3: true,
      username: "",
      verificationCode: "",
      requiredFieldRules: [v => !!v || "This field is required"],
      newPassword: "",
      newPasswordRules: [
        v => !!v || "This field is required",
        v => (v && v.length >= 8) || "Password must be 8 characters or more"
      ],
      confirmPassword: ""
    };
  },

  watch: {
    newPassword: "validatePasswords",
    confirmPassword: "validatePasswords"
  },

  methods: {
    validatePasswords() {
      return this.$refs.form3.validate();
    },

    async sendResetCode() {
      if (this.$refs.form1.validate()) {
        const data = {
          username: this.selectedUsername
        };

        await this.$store
          .dispatch("sendResetCode", data)
          .then(() => {
            this.e1 = 2;
          })
          .catch(() => (this.e1 = 1));
      }
    },

    sendResetCode2() {
      if (this.$refs.form2.validate()) {
        this.sendResetCode();
      }
    },

    async verifyResetCode() {
      if (this.$refs.form2.validate()) {
        const data = {
          username: this.selectedUsername,
          code: this.verificationCode
        };

        await this.$store
          .dispatch("verifyResetCode", data)
          .then(() => {
            this.e1 = 3;
          })
          .catch(() => (this.e1 = 2));
      }
    },

    async resetPassword() {
      if (this.validatePasswords()) {
        const data = {
          username: this.selectedUsername,
          code: this.verificationCode,
          new_password: this.newPassword,
          new_password_confirmation: this.confirmPassword
        };

        await this.$store.dispatch("resetPassword", data).then(() => {
          this.$router.push({ name: "login" });
        });
      }
    }
  },
  computed: {
    cardWidth() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs") {
        return "99vw";
      } else {
        return "45vw";
      }
    },

    confirmPasswordRules() {
      const rules = [];
      const rule1 = v => !!v || "This field is required";
      rules.push(rule1);
      if (this.confirmPassword) {
        const rule2 = v =>
          (!!v && v) === this.newPassword || "Passwords do not match";
        rules.push(rule2);
      }
      return rules;
    },

    storeUsername: {
      get() {
        const user = this.$store.state.user;
        if (user) {
          return user.username;
        } else return "";
      },

      set: function(value) {
        this.username = value;
      }
    },

    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },

    selectedUsername() {
      const user = this.$store.state.user;
      if (user) return user.username;
      else return this.username;
    }
  }
};
</script>